import React, { Fragment, useEffect, useState } from 'react';
import { Box, Button, Card, Flex, Heading, Text } from 'rebass/styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import gql from 'graphql-tag';
import styled from 'styled-components';

import TextInput from '../components/TextInput';
import FormField from '../components/FormField';
import Header from '../components/Header';
import withAnalytics from '../lib/withAnalytics';
import LoadingScreen from '../components/LoadingScreen';
import FullLayout2 from '../components/FullLayout';
import { useMutation } from '@apollo/client';
import { CleanDom } from '../utils/domCleanup';
import { IOkPayload } from '../graphql/types/mutations/generics';

const schema = Yup.object().shape({
  email: Yup.string()
    .email('invalid email address')
    .required('Required'),
});

const TRIGGER_RESET = gql`
  mutation healthCoachTriggerReset($email: String!) {
    healthCoachTriggerReset(email: $email) {
      ok
    }
  }
`;

interface ITriggerResetOutput {
  healthCoachTriggerReset: IOkPayload
}

interface ITriggerResetInput {
  email: string
}

const Container = styled(Box)`
  max-width: 1024px;
  width: 100%;
  margin: 0 auto !important;
`;

const CardContainer = styled(Flex)`
  max-width: 400px;
`;

const ForgotPassword: React.FC<{ analytics: any }> = ({ analytics }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false);
  const [triggerMutate, { loading, data }] = useMutation<ITriggerResetOutput, ITriggerResetInput>(TRIGGER_RESET)
  useEffect(() => {
    analytics.page();
    localStorage.removeItem('initialToken');
    sessionStorage.removeItem('lastTimeStamp');
    CleanDom()
  }, [])

  const handleSubmit = async (values: any) => {
    setIsLoading(true);

   await triggerMutate({
      variables: {
        email: values.email
      }
    })
    setIsLoading(false);
  };

  if (isLoading) {
    return <LoadingScreen loading={true} />;
  }

  if (!!data && !!data.healthCoachTriggerReset && !!data.healthCoachTriggerReset.ok) {
    return (
      <FullLayout2 style={{ overflow: 'auto', zIndex: 10 }}>
        <Fragment>
          <Container>
            <Flex flex={1} flexDirection="column">
              <Header dark={false} childContainerStyle={{ marginTop: '-16px' }}>
              <Heading sx={{ marginLeft: '97px' }}>Health Coaches</Heading>
              </Header>
            </Flex>
            <Flex flex={1} alignItems="center" justifyContent="center">
              <CardContainer flex={1} px={3}>
                <Card p={4}>
                  <Flex flexDirection="column">
                    <Box mb={4}>
                      <Heading textAlign="center" mb={3}>
                        Reset Your Password
                      </Heading>

                      <Text textAlign="center">
                        An email with further instructions has been sent to
                        the address provided. Check the spam folder if you
                        don't see the email.
                      </Text>
                    </Box>
                  </Flex>
                </Card>
              </CardContainer>
            </Flex>
          </Container>
        </Fragment>
      </FullLayout2>)
  }

  return (
    <FullLayout2 style={{ overflow: 'auto', zIndex: 10 }}>
      <Fragment>
        <Container>
          <Flex flex={1} flexDirection="column">
            <Header dark={false} childContainerStyle={{ marginTop: '-16px' }}>
              <Heading sx={{ marginLeft: '97px' }}>Health Coaches</Heading>
            </Header>
          </Flex>
          <Flex flex={1} alignItems="center" justifyContent="center">
            <CardContainer flex={1} px={3}>
              <Card p={4}>
                <Flex flexDirection="column">
                  <Box mb={4}>
                    <Heading textAlign="center" mb={3}>
                      Reset Your Password
                    </Heading>
                  </Box>
                  <Fragment>
                    <Formik
                      initialValues={{
                        email: '',
                      }}
                      isInitialValid={() => {
                        try {
                          const aa = schema.validateSync({
                            email: '',
                          });

                          if (aa.email) {
                            return false;
                          }
                          return true;
                        } catch (err) {
                          return false;
                        }
                      }}
                      validationSchema={schema}
                      onSubmit={(values) => handleSubmit(values)}
                      render={({ touched, errors, isValid }) => {
                        return (
                          <>
                            <Form>
                              <FormField mb={3} error={touched.email && errors.email}>
                                <TextInput placeholder="Your email address" type="email" name="email" id="input_email" />
                              </FormField>


                              <Flex alignItems="center" flexDirection="column">
                                <Button disabled={!isValid || loading || isLoading} variant="primary" width={1 / 2} type="submit" id="btn_login">
                                  Get Reset Link
                                </Button>
                              </Flex>
                            </Form>

                          </>
                        );
                      }} />

                  </Fragment>
                </Flex>
              </Card>
            </CardContainer>
          </Flex>
        </Container>
      </Fragment>
    </FullLayout2>
  );
};

// export default withAnalytics(withToastManager(Login));
export default withAnalytics(ForgotPassword);
